import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { IElementoEstandarDTO } from "../../../../../Interfaces/hazard/IHazard";
import { UsePanelEditarElemento } from "./UsePanelEditarElemento";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { TextField } from "@fluentui/react";

export interface IPanelEditarElemento extends IOpenPanel{
    item: IElementoEstandarDTO
}
export const PanelEditarElemento=(props:IPanelEditarElemento)=>{
    const {request,setRequest,putEditarElemento,loading,reset,mensaje,status} = UsePanelEditarElemento(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Editar"
              texto2={"Salir"}
              onClick={putEditarElemento}
              onDismiss={reset}
            />
          </>
        ),
        [request]
      )
      return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Editar Elemento Estandat"} 
        status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
           <TextField 
           type="text"
           label="Nombre de Elemento Estandat"
           placeholder="Ingrese Nombre de Elemento Estandar"
           autoComplete="off"
           value={request.nombreEstandar}
           onChange={(event,newValue)=>{
              if(newValue!=null){
              setRequest({...request,nombreEstandar:newValue})}
           }}
           />
        </PanelDrawer>
      )

}